import { TcpaState } from './TCPATypes';

export const TcpaActionTypes = {
  EDITOR_SHOW: 'TCPA_EDITOR_SHOW',
  EDITOR_HIDE: 'TCPA_EDITOR_HIDE',
  EDITOR_LOAD: 'TCPA_EDITOR_LOAD',
  ALERT_DISPLAY: 'TCPA_ALERT_DISPLAY',
  GRID_RELOAD: 'TCPA_GRID_RELOAD',
  GRID_RELOADED_LIST: 'TCPA_GRID_RELOADED_LIST',
  GRID_PERMISSION: 'TCPA_GRID_PERMISSION',
  GRID_SORT: 'TCPA_GRID_SORT',
  GRID_SEARCH: 'TCPA_GRID_SEARCH',
};

export const TcpaApiPaths = {
  GET: '/Get',
  CREATE: '/Add',
  UPDATE: '/Update',
  PERMISSION: '/AdminAuthorization',
  HISTORY: '/History',
};

export const TcpaDefaults: TcpaState = {
  alert: {
    type: 'none',
    content: '',
  },
  editor: {
    modal: false,
    data: {
      id: undefined,
      company: '',
      tcpa: '',
    },
  },
  grid: {
    rows: [],
    search: '',
    sort: {
      index: 'Company',
      order: 'asc',
    },
    edittable: true,
    reload: false,
  },
};

export const TcpaEditorSettings = {
  disallowedContent: 'label(*)[*]{*};',
  autoParagraph: false,
  extraPlugins: 'sourcedialog',
  removePlugins: 'sourcearea',
};

export const TcpaGridHeaders = [
  {
    title: 'Company',
    index: 'Company',
  },
  {
    title: 'TCPA Content',
    index: 'TcpaContent',
  },
];
